function resolvePartialUrl(src) {
  const raw = (src || "").trim();
  if (!raw || raw.startsWith("http://") || raw.startsWith("https://")) return raw;
  const rel = raw.replace(/^\.\//, "").replace(/^\.\.\//, "");
  return `${import.meta.env.BASE_URL}${rel}`;
}

async function loadPartials() {
  const loads = document.querySelectorAll("load");
  for (const el of loads) {
    const src = el.getAttribute("src");
    if (src) {
      const url = resolvePartialUrl(src);
      const res = await fetch(url);
      if (res.ok) {
        const html = (await res.text()).replaceAll(
          "{{BASE}}",
          import.meta.env.BASE_URL,
        );
        const wrapper = document.createElement("div");
        wrapper.innerHTML = html;
        el.replaceWith(wrapper);
      } else {
        console.error("Partial yüklenemedi:", url);
      }
    }
  }
}
loadPartials().then(async () => {
  await import("./js/index.js");
});
